var map = {
	"./AmigoMenu.png": "709b",
	"./CartaoMenu.png": "fe0c",
	"./ComprasMenu.png": "2c1a",
	"./CotacoesMenu.png": "5b7d",
	"./DescontoMenu.png": "2059",
	"./EventosMenu.png": "0acf",
	"./FinanceiroMenu.png": "b139",
	"./PagamentoRapido.png": "bcdf",
	"./RastreamentoMenu.png": "8975",
	"./ReboqueRapido.png": "66a3",
	"./RegulamentoMenu.png": "b270",
	"./TermosMenu.png": "11cd",
	"./VeiculosMenu.png": "b2a4",
	"./VistoriaRapido.png": "66af",
	"./icon-whatsapp.svg": "fb77"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "32fc";